import React from 'react';
import './Footer.css'; 

function Footer() {
  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
        
        <div className="site-footer__info">
          
          <a href="https://britishprogress.org" target="_blank" rel="noopener noreferrer">
            <div className="site-footer__info-inner">
              <p className="site-footer__info-text">Powered by</p>
              <img src="/images/cbp_white.svg" alt="Centre for British Progress" className="cbp-logo"/>
            </div>
          </a>
        </div>
      
        <nav className="site-footer__links">
        </nav>

      </div>
    </footer>
  );
}

export default Footer;
